import { render, staticRenderFns } from "./addWorks.vue?vue&type=template&id=680322fd&"
import script from "./addWorks.vue?vue&type=script&lang=js&"
export * from "./addWorks.vue?vue&type=script&lang=js&"
import style0 from "./addWorks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports